import { RequestActionModel } from "../models/RequestActionModel";
import RequestModel from "../models/RequestModel";

const prepareActions = (data: RequestActionModel[]): RequestActionModel[] => {
    data.forEach(action => {
        if(action?.actionDate)
            action.actionDate = new Date(action.actionDate);
        if(action?.bringForwardDate)
            action.bringForwardDate = new Date(action.bringForwardDate);
    });

    return data;
};

export const prepareRequestModel = (data: RequestModel): RequestModel => {
    if(data?.dateReceived) data.dateReceived = new Date(data.dateReceived);
    if(data?.dueDate) data.dueDate = new Date(data.dueDate);
    if(data?.completedDate) data.completedDate = new Date(data.completedDate);
    if(data?.requestActions) data.requestActions = prepareActions(data.requestActions);

    if(data.sharepointUrl) data.sharepointUrl = decodeURIComponent(data.sharepointUrl);
    data.notes ??= '';

    return data;
};
